// extracted by mini-css-extract-plugin
export default {"adminRow":"AdminUsuarios_adminRow__oLCPe"};